import { useState } from "react";
import type { MembersChangeRequestView } from "../../../../api/types/membersChangeRequestTypes";
import PendingChangesAlert from "../common/PendingChangesAlert";
import MembersChangeRequestDialog from "./MembersChangeRequestDialog";

interface Props {
  canUserEdit: boolean;
  investorId: string;
  changeRequest: MembersChangeRequestView;
  onChangeRequestCanceled: () => void;
}

const MembersChangeRequestStatus = ({ canUserEdit, investorId, changeRequest, onChangeRequestCanceled }: Props) => {
  const [showDialog, setShowDialog] = useState(false);

  if (!changeRequest.changeRequestId) {
    return null;
  }

  const handleChangeRequestCanceled = () => {
    setShowDialog(false);
    onChangeRequestCanceled();
  };

  return (
    <>
      <PendingChangesAlert
        pendingChangeRequest={{
          referenceCode: changeRequest.referenceCode ?? "",
          requestedByUserName: changeRequest.submittedByUserName ?? "",
          requestedAt: changeRequest.submittedAt ?? "",
        }}
        onViewRequest={() => setShowDialog(true)}
        hideSubmitter
      />
      <MembersChangeRequestDialog
        open={showDialog}
        onClose={() => setShowDialog(false)}
        canUserEdit={canUserEdit}
        investorId={investorId}
        changeRequest={changeRequest}
        onChangeRequestCanceled={handleChangeRequestCanceled}
      />
    </>
  );
};

export default MembersChangeRequestStatus;
